import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { format } from "date-fns";
import "./NewsroomPage.css";
import Instance from "../../Utils/Axios";
import PremiumLoader from "../Loader/PremiumLoader";

const NewsRoomDetailsPage = () => {
  const { id } = useParams();
  const [newsDetails, setNewsDetails] = useState(null);
  const [companyDetails, setCompanyDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const fetchNewsDetails = () => {
      Instance.get(`/site/newsroom/page?id=${id}`)
        .then((response) => {
          const data = response?.data?.message || response?.data;
          const newsData = Array.isArray(data) ? data[0] : data;

          const fetchedCompanyDetails = response?.data?.companyDetails || newsData?.companyDetails;

          if (newsData?.showContactDetails === "YES" && fetchedCompanyDetails) {
            setCompanyDetails(fetchedCompanyDetails);
          } else {
            setCompanyDetails(null);
          }

          if (newsData?.image && !String(newsData.image).includes('/')) {
            Instance.post("/user/gallery/getList", { galleryId: newsData.image })
              .then((galleryResponse) => {
                const galleryList = galleryResponse?.data?.message || [];
                const matchedGallery = galleryList.length > 0 ? galleryList[0] : null;
                if (matchedGallery) {
                  newsData.image = matchedGallery.imgUrl;
                }
                setNewsDetails(newsData);
                setLoading(false);
              })
              .catch((err) => {
                console.error("Error fetching gallery", err);
                setNewsDetails(newsData);
                setLoading(false);
              });
          } else {
            setNewsDetails(newsData);
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error("Error fetching news room details", error);
          setLoading(false);
        });
    };
    if (id) {
      fetchNewsDetails();
    }
  }, [id]);

  return (
    <>
      {loading ? (
        <PremiumLoader text="Loading News Details..." />
      ) : (
        <div className="newsroom_container">
          <div className="newsroom_layout">
            <div className="newsroom_details">
              {newsDetails ? (
                <div style={{ backgroundColor: 'white', borderRadius: '12px', border: '1px solid #e2e8f0', padding: '30px', boxSizing: 'border-box', width: '100%', overflow: 'hidden' }}>
                  <h2 className="newsroom_title" style={{ fontSize: '2rem', marginBottom: '10px', padding: '0', border: 'none', wordBreak: 'break-word', overflowWrap: 'anywhere' }}>
                    {newsDetails.title}
                  </h2>
                  <p style={{ color: '#666', marginBottom: '20px' }}>
                    {newsDetails.createdOn
                      ? format(new Date(newsDetails.createdOn), "MMM d, yyyy • h:mm a")
                      : ""}
                  </p>

                  {newsDetails.image && (
                    <div style={{ marginBottom: '20px', borderRadius: '8px', overflow: 'hidden', width: '100%' }}>
                      <img src={newsDetails.image} alt={newsDetails.title} style={{ maxWidth: '100%', height: 'auto', display: 'block' }} />
                    </div>
                  )}

                  <div
                    className="newsroom_content"
                    style={{ wordBreak: 'break-word', overflowWrap: 'anywhere' }}
                    dangerouslySetInnerHTML={{ __html: newsDetails.content || newsDetails.description || "" }}
                  />

                  {newsDetails.showContactDetails === "YES" && companyDetails && (
                    <div className="contact_details_section" style={{ marginTop: '24px', backgroundColor: '#f8fafc', padding: '16px 20px', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                      <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#1e293b', margin: '0 0 12px 0', borderBottom: '1px solid #e2e8f0', paddingBottom: '8px' }}>Contact Details</h3>
                      <div style={{ display: 'grid', gridTemplateColumns: 'max-content 1fr', rowGap: '8px', columnGap: '16px' }}>
                        {companyDetails.name && <><span style={{ color: '#64748b', fontSize: '14px', fontWeight: '500' }}>Company Name</span><span style={{ color: '#1e293b', fontSize: '15px', fontWeight: '500', wordBreak: 'break-word' }}>{companyDetails.name}</span></>}
                        {companyDetails.contactPerson && <><span style={{ color: '#64748b', fontSize: '14px', fontWeight: '500' }}>Contact Person</span><span style={{ color: '#1e293b', fontSize: '15px', wordBreak: 'break-word' }}>{companyDetails.contactPerson}</span></>}
                        {companyDetails.email && (
                          <><span style={{ color: '#64748b', fontSize: '14px', fontWeight: '500' }}>Email Id</span><span style={{ color: '#1e293b', fontSize: '15px', wordBreak: 'break-word' }}><a href={`mailto:${companyDetails.email}`} style={{ color: '#3b82f6', textDecoration: 'none', fontWeight: '500' }}>{companyDetails.email}</a></span></>
                        )}
                        {companyDetails.mobile && <><span style={{ color: '#64748b', fontSize: '14px', fontWeight: '500' }}>Phone</span><span style={{ color: '#1e293b', fontSize: '15px', wordBreak: 'break-word' }}>{companyDetails.mobile}</span></>}
                        {companyDetails.website && (
                          <><span style={{ color: '#64748b', fontSize: '14px', fontWeight: '500' }}>Website</span><span style={{ color: 'break-word', fontSize: '15px', wordBreak: 'break-word' }}><a href={companyDetails.website.startsWith('http') ? companyDetails.website : `https://${companyDetails.website}`} target="_blank" rel="noopener noreferrer" style={{ color: '#3b82f6', textDecoration: 'none', fontWeight: '500' }}>{companyDetails.website}</a></span></>
                        )}
                        {companyDetails.country && <><span style={{ color: '#64748b', fontSize: '14px', fontWeight: '500' }}>Country</span><span style={{ color: '#1e293b', fontSize: '15px', wordBreak: 'break-word' }}>{companyDetails.country}</span></>}
                        {companyDetails.state && <><span style={{ color: '#64748b', fontSize: '14px', fontWeight: '500' }}>State</span><span style={{ color: '#1e293b', fontSize: '15px', wordBreak: 'break-word' }}>{companyDetails.state}</span></>}
                        {companyDetails.city && <><span style={{ color: '#64748b', fontSize: '14px', fontWeight: '500' }}>City</span><span style={{ color: '#1e293b', fontSize: '15px', wordBreak: 'break-word' }}>{companyDetails.city}</span></>}
                        {companyDetails.address && <><span style={{ color: '#64748b', fontSize: '14px', fontWeight: '500' }}>Address</span><span style={{ color: '#1e293b', fontSize: '15px', wordBreak: 'break-word' }}>{companyDetails.address}</span></>}
                        {newsDetails.categoryName && <><span style={{ color: '#64748b', fontSize: '14px', fontWeight: '500' }}>Categories</span><span style={{ color: '#1e293b', fontSize: '15px', wordBreak: 'break-word' }}>{newsDetails.categoryName}</span></>}
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <h5>News details not found</h5>
              )}
            </div>

            {/* <div className="pr_details">
              <h4 className="newsroom_title">Related Company PR</h4>
              <div className="newsroom_pr">
                <div className="pr_info">
                  <h5>Real Estate in Turkey</h5>
                  <p>
                    Blockchain-based social network BSocial arrives with a gathering
                    of distinctive features.
                  </p>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      )}
    </>
  );
};

export default NewsRoomDetailsPage;
